class DashboardConstants {
  static CHANGE_SPEED = 'Change Speed';
  static MOVE_ADDRESS = 'Move Address';
  static CONNECTION_DATE_DESCRIPTION = 'It can take up to 5 to 7 working days to get you sorted at your new address. '
    + 'In some cases it may take longer as we need the help of third parties to get you sorted. '
    + 'Unfortunately we don\'t have full control over third party appointments. We will get in touch as soon '
    + 'as we have confirmation when your broadband will be moved.';

  static NOT_AVAILABLE_DESCRIPTION = 'Sorry, it looks like your new address can\'t get Skinny Unlimited Broadband. '
    + 'We\'ll need to disconnect your line after you\'ve moved out.';
  static CHANGE_OR_EXISTING_OPTIONS = [
    { name: 'keepSpeed', id: 'keepSpeed', label: 'Keep my current speed', autotestClass: 'test-keep-speed-rb' },
    { name: 'newSpeed', id: 'newSpeed', label: 'Choose a new speed', autotestClass: 'test-new-speed-rb' }
  ];
}

export default DashboardConstants;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/DashboardConstants.js
 **/